import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../Components/Cta";
import { EmptyScreen, Loader } from "../../Components/Other";
import { DataTableComponent } from "../../Components/DataTable";
import Icon from "../../Components/icons";
import { APIService } from "../../Service";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function NotificationList() {
  const navigate = useNavigate();
  const [notificationList, setNotificationList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [btnLoader, setBtnLoader] = useState(false);
  const dispatch = useDispatch();
  // const count = useSelector((state) => state.admin.NOTIFICATION_COUNT);

  const _handleViewDetail = (notification) => {
    _readNotification(notification);
    if (notification.data_type === 1) {
      navigate(`/customer/detail/${notification.data_id}`);
    } else {
      navigate(`/orders/detail/${notification.data_id}`);
    }
  };

  const COLUMNS = [
    {
      name: "",
      sortable: true,
      cell: (row) => (
        <div className="d-flex w-100 column-gap-3">
          <div className=" d-flex justify-content-">
            <div
              style={{ width: 45, height: 45 }}
              className={`rounded-circle  d-flex justify-content-center align-items-center position-relative ${
                row.is_read ? "e-border-1px-light-silver" : "e-bg-blue-violet"
              }`}
            >
              <Icon
                icon="notification"
                size="22"
                color={row.is_read ? "#d7d7d7" : "white"}
              />
              {!row.is_read && <div className="e-notification-read"></div>}
            </div>
          </div>
          <div className="d-flex w-100">
            <div className="d-flex justify-content-start w-100 flex-column">
              <div className="d-flex align-items-center justify-content-between">
                <h5 className="m-0 e-primary-font-poppins e-font-weight-500 e-font-14 line-height-20px e-text-dark-silver">
                  {row.title}
                </h5>
                <p className="m-0 e-primary-font-poppins e-font-weight-400 e-font-10 e-text-dark-silver">
                  {row.created}
                </p>
              </div>
              <p className="m-0 e-primary-font-poppins e-font-weight-400 e-font-14 e-text-eerie-black pt-2">
                {row.description}
              </p>
              <div className="row">
                <div className="col-lg-4 col-6">
                  <PrimaryButton
                    name="View details"
                    // loading={btnLoader}
                    onPress={() => _handleViewDetail(row)}
                    ClassName="e-border-radius-pill ps-0 e-font-weight-500 e-font-14 py-2 bg-transparent e-text-blue-violet e-primary-font-poppins"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  // ---- fetch notifications ----
  const _getNotifications = () => {
    setLoader(true);
    const is_post = true;
    const payload = {
      page_num: currentPage,
      page_size: rowsPerPage,
    };

    APIService(is_post, "notification/get-received-notification", payload)
      .then((response) => {
        if (response.status_code === 200) {
          setNotificationList(response.data.data);
          setTotalRows(response.data.total_count || 0);
          setRowsPerPage(Number(response.data.page_size ?? rowsPerPage));
          setCurrentPage(Number(response.data.current_page ?? currentPage));
          setIsEmpty(response.data.data.length === 0);
        } else {
          setNotificationList([]);
          setTotalRows(0);
          setIsEmpty(true);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.error("Failed to fetch notifications:", err);
        setNotificationList([]);
        setTotalRows(0);
        setIsEmpty(true);
        setLoader(false);
      });
  };

  useEffect(() => {
    _getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, rowsPerPage]);

  // ---- handle row click (mark single notification read) ----
  // const _handleRowClick = (row) => {
  //   console.log(row);
  // };

  // ---- mark all as read ----
  const _markAllAsRead = () => {
    setBtnLoader(true);
    const is_post = false;
    APIService(is_post, "notification/read-all")
      .then((resp) => {
        if (resp && resp.status_code === 200) {
          setNotificationList((prev) =>
            prev.map((n) => ({ ...n, is_read: true }))
          );
          window.location.reload(false);
        } else {
          console.error("Mark all read failed:", resp);
        }
        setBtnLoader(false);
      })
      .catch((err) => {
        console.error("Mark all read error:", err);
        setBtnLoader(false);
      });
  };

  const _readNotification = (notification) => {
    setBtnLoader(true);
    const is_post = true;
    const payload = {
      notification_id: notification.notification_id,
    };
    APIService(is_post, "notification/read", payload)
      .then((resp) => {
        if (resp && resp.status_code === 200) {
          dispatch({ type: "DECREMENT_NOTIFICATION_COUNT" });
          _getNotifications();
        } else {
          console.error("Mark all read failed:", resp);
        }
        setBtnLoader(false);
      })
      .catch((err) => {
        console.error("Mark all read error:", err);
        setBtnLoader(false);
      });
  };

  return (
    <div className="row px-2 pt-3">
      <div className="col-12">
        <div className="d-flex justify-content-end pb-3">
          <PrimaryButton
            name="Mark all as read"
            loading={btnLoader}
            onPress={_markAllAsRead}
            ClassName="e-border-radius-pill e-font-weight-400 e-font-14 py-2 bg-transparent e-text-blue-violet e-primary-font-poppins"
          />
        </div>
        {isEmpty ? (
          <div className="d-flex min-h-100vh justify-content-center align-items-center">
            <EmptyScreen width={200} message="No Data Found" />
          </div>
        ) : loader ? (
          <div className="d-flex min-h-100vh justify-content-center align-items-center">
            <Loader type={2} width={30} />
          </div>
        ) : (
          <div className="row w-100 d-flex ms-1">
            <DataTableComponent
              columns={COLUMNS}
              data={notificationList}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationPerPage={rowsPerPage}
              currentPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              onChangeRowsPerPage={(newPerPage, page) => {
                setRowsPerPage(newPerPage);
                setCurrentPage(page || 1);
              }}
              sortIcon={<Icon icon="sort_col" size="20px" />}
              className="e-notificationsList-table"
            />
          </div>
        )}
      </div>
    </div>
  );
}
